import { Anchor, type _Navigation } from ":setup/qrouter";
import { default as routes } from "../routes";

export default function Profile(props: _Navigation.SideNavJSXItemProps) {
  return (
    <Anchor
      class={props.anchor?.class}
      setup={{
        to: routes,
        classes: {
          active: `${props.anchor.setup.classes.active}`,
        },
      }}
      options={{
        activeOnBase: true,
      }}
      components={{
        title: "Profile Settings",
        idleIcon: <i class="i-fluent:settings-28-regular" />,
        activeIcon: <i class="i-fluent:settings-28-regular" />,
      }}
    />
  );
}
